<script lang="ts">
  import { gallery } from '../lib/gallery.svelte';

  let visible = $state(false);
  let timer: ReturnType<typeof setTimeout> | undefined;

  // Reveal the title briefly on each photo change, then fade out.
  $effect(() => {
    const current = gallery.current;
    if (!current) {
      visible = false;
      return;
    }
    visible = true;
    clearTimeout(timer);
    timer = setTimeout(() => (visible = false), 2600);
    return () => clearTimeout(timer);
  });
</script>

{#if gallery.current}
  <div class="overlay" class:visible aria-hidden="true">
    <div class="path">{gallery.breadcrumb.join(' / ')}</div>
    <div class="title">{gallery.current.title}</div>
  </div>
{/if}

<style>
  .overlay {
    position: fixed;
    left: max(16px, env(safe-area-inset-left));
    bottom: max(18px, env(safe-area-inset-bottom));
    z-index: 20;
    pointer-events: none;
    opacity: 0;
    transform: translateY(4px);
    transition:
      opacity 0.6s var(--ease),
      transform 0.6s var(--ease);
    text-shadow: 0 1px 12px rgba(0, 0, 0, 0.75);
    max-width: min(70vw, 520px);
  }
  .overlay.visible {
    opacity: 1;
    transform: translateY(0);
  }

  .path {
    font-size: 0.72rem;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--muted);
    margin-bottom: 0.15rem;
  }
  .title {
    font-size: 1.05rem;
    font-weight: 500;
    color: var(--fg);
  }
</style>
